import {HttpClient, HttpParams} from '@angular/common/http';
import { computed, Injectable, Signal, inject } from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {FeatureFlag} from '../models/feature-flag.model';
import {selectAllFeatureFlags} from '../state/feature-flag.selectors';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private readonly http = inject(HttpClient);
  private readonly store = inject(Store);

  private static readonly getFeatureFlagUrl = `${environment.api.baseUrl}/${environment.api.featureFlag.getFeatureFlag}`;
  private readonly flagsSignal: Signal<FeatureFlag[]> = toSignal(this.store.select(selectAllFeatureFlags), {
    initialValue: [],
  });
  constructor() {
    this.flagsSignal = toSignal(this.store.select(selectAllFeatureFlags), {initialValue: []});
  }

  isFlagEnabled(featureFlagName: string): Signal<boolean> {
    return computed(() => {
      const flag = this.flagsSignal().find(flag => flag.flagName === featureFlagName);
      console.log(featureFlagName, flag);
      return !!flag?.isEnabled;
    });
  }

  getFeatureFlagValue(featureFlagName: string): Signal<string | null> {
    return computed(() => {
      const flag = this.flagsSignal().find(f => f.flagName === featureFlagName);
      return flag?.isEnabled ? (flag.value ?? null) : null;
    });
  }

  fetchFeatureFlags(flagName: string, flagType: number): Observable<FeatureFlag> {
    const params = new HttpParams().set('flagName', flagName).set('flagType', flagType);
    return this.http.get<FeatureFlag>(FeatureFlagService.getFeatureFlagUrl, {params});
  }
}
